import { valueToColor } from '../../utils/colorUtils';
import StyleFactory, { getNumberFromFeatureProps, getAreaLabelFromFeature, getAreaValueFromFeature, getPropFromFeature } from '../../StyleFactory';
import arrowGeometry from '../geom/arrowGeometry';
export const themeSelector = (value, theme) => ({
  color: theme.color
});
export const areaThemeSelector = (value, theme) => ({
  color: valueToColor(theme.color, value, theme.min, theme.max)
});
const gridView = StyleFactory.createStyle({
  geometry: arrowGeometry({
    sizeFactor: 10
  }),
  valueSelector: getNumberFromFeatureProps(),
  labelSelector: null,
  themeSelector
});
export default {
  grid: gridView,
  line: StyleFactory.createDefaultIsolineStyle(themeSelector),
  area: StyleFactory.createDefaultAreaStyle(areaThemeSelector)
};